import { Switch, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { EmailLevel, User } from '@xver/@types/user';
import DialogBox from '@xver/components/Atoms/DialogBox/DialogBox';

import { useToggle2FAMutation } from '../hooks/useToggle2FAMutation';

interface TwoFactorSectionProps {
    user: User;
}

export default function TwoFactorSection({ user }: TwoFactorSectionProps) {
    const { t } = useTranslation('security');
    const mutation = useToggle2FAMutation();

    const emailVerified = user.verifyEmailAddress === EmailLevel.E2;
    const switchEl = (
        <Switch
            checked={user.twoFactorEnabled}
            onChange={(e) => mutation.mutate(e.currentTarget.checked)}
            disabled={!emailVerified || mutation.isPending}
            size="md"
            label={user.twoFactorEnabled ? t('twoFactor.enabled') : t('twoFactor.disabled')}
        />
    );

    return (
        <DialogBox
            label={t('twoFactor.title')}
            description={t('twoFactor.description')}
            classNames="p-4"
        >
            {emailVerified ? (
                switchEl
            ) : (
                <Tooltip label={t('twoFactor.requireEmailVerified')} withArrow>
                    <div className="inline-block">{switchEl}</div>
                </Tooltip>
            )}
        </DialogBox>
    );
}
